import React, { useState, useEffect } from "react";
import { BiLogoTelegram } from "react-icons/bi";
import styles from "./Popup.module.css";
import { FaTimes } from "react-icons/fa"; // Importa el ícono de cerrar
import imagenCheck from "../../../assets/img/lol.webp";
import { toast } from "react-toastify";
import { ThanksMessage } from "../ThanksMessage";
export const Popup = ({ titulo, isDistributor }) => {
  const [showPopup, setShowPopup] = useState(true);
  const [mensaje, setMensaje] = useState("");
  const [enviado, setEnviado] = useState(false); // Estado para manejar si el mensaje fue enviado
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 1000000); // Ajusta este valor según sea necesario

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleMensajeChange = (e) => {
    setMensaje(e.target.value);
  };

  const handleEnviar = (e) => {
    e.preventDefault();
    if (mensaje) {
      const subject = encodeURIComponent(
        "Quiero mantenerme actualizado. Este es mi número " + mensaje
      ); // Codifica el mensaje para usarlo en el asunto
      window.location.href = `mailto:Clientes@vogueelsalvador.com?subject=${subject}`;
      setEnviado(true); // Actualiza el estado a enviado
    } else {
      toast.error("Número invalido", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <>
      {showPopup && (
        <div className={isDistributor ? styles.popupDistributor : styles.popup}>
          <div className={styles.closeButton} onClick={handleClosePopup}>
            <FaTimes />
          </div>
          {!enviado ? ( // Verifica si el mensaje ha sido enviado
            <>
              <h2
                className={
                  isDistributor ? styles.titleDistributor : styles.titulo
                }
              >
                {titulo}
              </h2>
              <div className={styles.content}>
                {isDistributor ? (
                  <input
                    type="number"
                    className={styles.inputPopupDistributor}
                    placeholder="Teléfono"
                    onChange={handleMensajeChange}
                  />
                ) : (
                  <textarea
                    className={styles.inputTextareaPopup}
                    placeholder="Ingrese su mensaje"
                    value={mensaje}
                    onChange={handleMensajeChange}
                  />
                )}
                {isDistributor ? (
                  <button
                    type="submit"
                    className={styles.sendPhoneNumber}
                    onClick={handleEnviar}
                  >
                    <BiLogoTelegram color="white" size={30} />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className={styles.enviar}
                    onClick={handleEnviar}
                  >
                    Enviar
                  </button>
                )}
              </div>
            </>
          ) : isDistributor ? (
            <ThanksMessage />
          ) : (
            <div className={styles.confirmacion}>
              Inscripción del newletter
              <img className={styles.check} src={imagenCheck} alt="" />
            </div> // Mensaje de confirmación después de enviar)
          )}
        </div>
      )}
    </>
  );
};
